import Swiper from "./../imports/import-swiper";
import scrollSpy from "simple-scrollspy";

export default () => {
    heroSlider();
    sliderNews();
    newsSliderItemHeight();
    regionSelectedHome();


    function heroSlider() {
        const sliderEl = document.querySelector(".heroSlider");
        if (sliderEl) {
            const slider = new Swiper(sliderEl, {
                loop: true,
                wrapperClass: "swiper-wrapper",
                slideClass: "swiper-slide",
                slidesPerView: 1,
                touchEventsTarget: "container",
                autoplay: {
                    delay: 5000,
                },
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                    clickable: true,
                },
                speed: 800,
            });
        }
    }


    function sliderNews() {
        const sliderEl = document.querySelector(".news-slider");
        if (sliderEl) {
            const slider = new Swiper(sliderEl, {
                loop: true,
                wrapperClass: "swiper-wrapper",
                slideClass: "swiper-slide",
                spaceBetween: 21,
                slidesPerView: 2,
                /*width: '100%',*/
                pagination: {
                    el: ".swiper-pagination-news",
                    type: "bullets",
                    clickable: true,
                },
                speed: 800,
                breakpoints: {
                    1023: {
                        slidesPerView: 1,
                        width: 500,
                    },
                    767: {
                        slidesPerView: 1,
                        width: 302,
                    }
                },
            });
        }
    }


    const HEADER_HEIGHT = 102;
    const options = {
        sectionClass: ".scrollspy", // Query selector to your sections
        menuActiveTarget: ".menu-item-link", // Query selector to your elements that will be added `active` class
        offset: window.innerHeight / 2 - HEADER_HEIGHT, // Menu item will active before scroll to a matched section 100px
    };

    scrollSpy("#side-scroll", options);

    const darkBgs = document.querySelectorAll('[data-color="dark"]');
    const scroll = document.querySelector(".side-scroll");

    document.addEventListener("scroll", () => {
        darkBgs.forEach((section) => {
            const sectionRect = section.getBoundingClientRect();
            if (
                sectionRect.y < window.innerHeight / 2 &&
                sectionRect.y + sectionRect.height > window.innerHeight / 2
            ) {
                section.classList.add("current");
            } else {
                section.classList.remove("current");
            }
        });

        let sect = document.querySelector(".current");
        if (sect) {
            scroll.classList.add("dark");
        } else {
            scroll.classList.remove("dark");
        }
    });

    function regionSelectedHome(){
      let optionsRegions = document.querySelector('.regionSelectCommon');
      let optionsCities = document.querySelector('.CitiesSelectCommon');
      optionsRegions.addEventListener('change', function (e) {
          let target = e.target;
          let currentVal = target.value;
          if (currentVal !== '') {
              optionsCities.closest('.location-wrapper').classList.remove('noActive');
          } else {
              optionsCities.closest('.location-wrapper').classList.add('noActive');
          }
      });
    }


    function newsSliderItemHeight(){
        let slider = document.querySelector('.news-slider');
        let sliderItem = slider.querySelectorAll('.news-content-block');
        let height = 0;
        sliderItem.forEach((item) => {
            if(item.clientHeight > height){
                height = item.clientHeight
            }
        });
        sliderItem.forEach((item) => {
            item.style.height = height+'px';
        });
    }
};
